// @ts-nocheck
import Button from 'components/base/Button';
import AuthSocialButtons from 'components/common/AuthSocialButtons';
import { Col, Form, Row } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import { toast, Zoom } from 'react-toastify';

import { useState, UseEffect } from 'react';
import axios from 'axios';

const SignUpForm = ({ layout }: { layout: 'simple' | 'card' | 'split' }) => {
  const [regName, setRegName] = useState('');
  const [regEmail, setRegEmail] = useState('');
  const [regPasswort, setRegPasswort] = useState('');
  const [regPasswortRepeat, setRegPasswortRepeat] = useState('');
  const [passwortNotDuplicated, setPasswortNotDuplicated] = useState(true);
  const [regMagicWord, setRegMagicWord] = useState('');

  const doRegNameHandler = e => {
    setRegName(e.target.value);
  };

  const doRegEmailHandler = e => {
    setRegEmail(e.target.value);
  };

  const doRegPasswortHandler = e => {
    setRegPasswort(e.target.value);
  };

  const doRegPasswortRepeatHandler = e => {
    setRegPasswortRepeat(e.target.value);
    if (regPasswort != regPasswortRepeat || regPasswort == '') {
      setPasswortNotDuplicated(true);
    }
  };

  const doRegMagicWordHandler = e => {
    setRegMagicWord(e.target.value);
  };

  const registerNewUser = () => {
    if (!passwortNotDuplicated) {
      toast.error('Passwörter stimmen nicht überein', {
        position: 'top-center',
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: false,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: 'dark',
        transition: Zoom
      });
    } else {
      axios({
        method: 'POST',
        url: `${process.env.REACT_APP_AUTH_API}/signup`,
        data: {
          name: regName,
          email: regEmail,
          password: regPasswort,
          confirmPassword: regPasswortRepeat,
          magicword: regMagicWord
        }
      })
        .then(response => {
          if (response.status === 200) {
            toast.success('Registrierung erfolgreich', {
              position: 'top-center',
              autoClose: 5000,
              hideProgressBar: false,
              closeOnClick: false,
              pauseOnHover: true,
              draggable: true,
              progress: undefined,
              theme: 'dark',
              transition: Zoom
            });
          } else if (response.status === 201) {
            toast.error('Passwörter stimmen nicht überein', {
              position: 'top-center',
              autoClose: 5000,
              hideProgressBar: false,
              closeOnClick: false,
              pauseOnHover: true,
              draggable: true,
              progress: undefined,
              theme: 'dark',
              transition: Zoom
            });
          } else if (response.status === 202) {
            toast.error('Magic Word war inkorrekt', {
              position: 'top-center',
              autoClose: 5000,
              hideProgressBar: false,
              closeOnClick: false,
              pauseOnHover: true,
              draggable: true,
              progress: undefined,
              theme: 'dark',
              transition: Zoom
            });
          } else {
            toast.error('Catch: Keine Verbindung zum Server', {
              position: 'top-center',
              autoClose: 5000,
              hideProgressBar: false,
              closeOnClick: false,
              pauseOnHover: true,
              draggable: true,
              progress: undefined,
              theme: 'dark',
              transition: Zoom
            });
          }
        })
        .catch(error => {
          toast.error('Keine Verbindung zum Server', {
            position: 'top-center',
            autoClose: 5000,
            hideProgressBar: false,
            closeOnClick: false,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            theme: 'dark',
            transition: Zoom
          });
        });
    }
  };
  return (
    <>
      <div className="text-center mb-7">
        <h3 className="text-body-highlight">Registrieren</h3>
        <p className="text-body-tertiary">PRIMEDECO for the WORLD</p>
      </div>

      <div className="position-relative mt-4">
        <hr className="bg-body-secondary" />
        <div className="divider-content-center">Let's get down to business</div>
      </div>
      <Form>
        <Form.Group className="mb-3 text-start">
          <Form.Label htmlFor="name">Name</Form.Label>
          <Form.Control
            id="name"
            type="text"
            placeholder="Name"
            onChange={doRegNameHandler}
          />
        </Form.Group>
        <Form.Group className="mb-3 text-start">
          <Form.Label htmlFor="email">Email addresse</Form.Label>
          <Form.Control
            id="email"
            type="email"
            placeholder="name@example.com"
            onChange={doRegEmailHandler}
          />
        </Form.Group>
        <Row className="g-3 mb-3">
          <Col sm={layout === 'card' ? 12 : 6} lg={6}>
            <Form.Group>
              <Form.Label htmlFor="password">Passwort</Form.Label>
              <Form.Control
                id="password"
                type="password"
                placeholder="Passwort"
                onChange={doRegPasswortHandler}
              />
            </Form.Group>
          </Col>
          <Col sm={layout === 'card' ? 12 : 6} lg={6}>
            <Form.Group>
              <Form.Label htmlFor="confirmPassword">
                Passwort bestätigen
              </Form.Label>
              <Form.Control
                id="confirmPassword"
                type="password"
                placeholder="Passwort bestätigen"
                onChange={doRegPasswortRepeatHandler}
              />
            </Form.Group>
          </Col>
          <Form.Group className="mb-3 text-start">
            <Form.Label htmlFor="email">Magic Word</Form.Label>
            <Form.Control
              id="magicword"
              type="text"
              placeholder="magicword"
              onChange={doRegMagicWordHandler}
            />
          </Form.Group>
        </Row>

        <Button
          onClick={registerNewUser}
          variant="primary"
          className="w-100 mb-3"
        >
          Registrieren
        </Button>
        <div className="text-center">
          <Link to={`/auth/sign-in`} className="fs-9 fw-bold">
            Anmelden
          </Link>
        </div>
      </Form>
    </>
  );
};

export default SignUpForm;
